import React, { useEffect, Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Heart, Sparkles, BookOpen, Feather } from 'lucide-react';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { TestimonialCard } from '../components/TestimonialCard';
const CHECKOUT_URL = 'https://checkout2.rosetadigital.com/cart/46949317345458:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/rGNxsH6DDPNhjoWZUC1TZJ/ChatGPT_Image_24_dic_2025,_02_59_07.png';
const BONUS_IMAGE = 'https://cdn.magicpatterns.com/uploads/idda2cUFkLZUANZxNmSeDT/ChatGPT_Image_27_dic_2025,_12_12_36.png';
const BONUS_IMAGE_2 = 'https://cdn.magicpatterns.com/uploads/eRBWVd67Cj65gGkSPoCC6b/ChatGPT_Image_27_dic_2025,_12_09_55.png';
const BONUS_IMAGE_3 = 'https://cdn.magicpatterns.com/uploads/o4JHmwpes2V5j79a84ADCQ/ChatGPT_Image_27_dic_2025,_12_08_15.png';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
const stagger = {
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};
export function SanarSinCulpa() {
  useEffect(() => {
    document.title = 'Sanar Sin Culpa - Guía de Sanación Interior';
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#FAF9F6] font-sans text-gray-800 overflow-x-hidden" data-id="element-21">
      <SocialProofPopup data-id="element-22" />

      {/* Navigation / Top Bar */}
      <nav className="w-full py-4 px-6 flex justify-center bg-white/50 backdrop-blur-md sticky top-0 z-40 border-b border-purple-100/50" data-id="element-23">
        <span className="font-serif text-xl text-purple-900 tracking-wide" data-id="element-24">
          Sanar Sin Culpa
        </span>
      </nav>

      {/* Hero Section */}
      <header className="relative pt-12 pb-20 px-4 md:px-8 lg:px-16 overflow-hidden" data-id="element-25">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-purple-50 via-pink-50/30 to-[#FAF9F6] -z-10" data-id="element-26" />

        {/* Decorative elements */}
        <div className="absolute top-20 left-10 w-64 h-64 bg-purple-200/20 rounded-full blur-3xl -z-10" data-id="element-27" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-pink-200/20 rounded-full blur-3xl -z-10" data-id="element-28" />

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-29">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} className="order-2 md:order-1" data-id="element-30">
            <span className="inline-block py-1 px-3 rounded-full bg-purple-100 text-purple-700 text-xs font-medium tracking-wider mb-6" data-id="element-31">
              GUÍA DE SANACIÓN INTERIOR
            </span>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-purple-900 leading-tight mb-6" data-id="element-32">
              SANAR SIN <br data-id="element-33" />
              <span className="italic text-purple-600" data-id="element-34">CULPA</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-8 max-w-lg" data-id="element-35">
              Hay mujeres que no se caen. No gritan. No piden ayuda.
              <br data-id="element-36" />
              <br data-id="element-37" />
              Solo siguen.
              <br data-id="element-38" />
              <br data-id="element-39" />
              Siguen funcionando, cumpliendo, sosteniendo… mientras por dentro
              se apagan de a poco.
              <br data-id="element-40" />
              <br data-id="element-41" />
              <span className="font-medium text-purple-800" data-id="element-42">
                Si este texto te toca, no es casualidad.
              </span>
            </p>
            <button onClick={scrollToPurchase} className="group bg-purple-900 text-white px-8 py-4 rounded-full font-medium text-lg shadow-lg shadow-purple-900/20 hover:bg-purple-800 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 flex items-center gap-2" data-id="element-43">
              Quiero sanar hoy
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-44" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="order-1 md:order-2 flex justify-center relative" data-id="element-45">
            <div className="relative w-full max-w-md aspect-[2/3] cursor-pointer group" onClick={scrollToPurchase} data-id="element-46">
              <div className="absolute inset-0 bg-purple-200 rounded-[2rem] rotate-3 group-hover:rotate-6 transition-transform duration-500 ease-out" data-id="element-47" />
              <img src={MAIN_IMAGE} alt="Sanar Sin Culpa Libro Digital" className="relative w-full h-full object-cover rounded-[2rem] shadow-2xl group-hover:-translate-y-2 transition-transform duration-500 ease-out" data-id="element-48" />
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-xl shadow-xl flex items-center gap-3 animate-bounce-slow" data-id="element-49">
                <div className="bg-pink-100 p-2 rounded-full" data-id="element-50">
                  <Heart className="w-6 h-6 text-pink-500 fill-pink-500" data-id="element-51" />
                </div>
                <div data-id="element-52">
                  <p className="text-xs text-gray-500 font-medium" data-id="element-53">
                    Más de 1.500
                  </p>
                  <p className="text-sm font-bold text-gray-900" data-id="element-54">
                    Mujeres sanando
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </header>

      {/* Problem Awareness Sections */}
      <section className="py-20 px-4 md:px-8 bg-white relative overflow-hidden" data-id="element-55">
        <div className="max-w-3xl mx-auto space-y-24" data-id="element-56">
          {/* Section 1 */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="text-center" data-id="element-57">
            <div className="w-12 h-12 mx-auto bg-purple-50 rounded-full flex items-center justify-center mb-6" data-id="element-58">
              <Feather className="w-6 h-6 text-purple-400" data-id="element-59" />
            </div>
            <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-6" data-id="element-60">
              Cuando ser fuerte deja de ser suficiente
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-61">
              Desde afuera parecés estable. Responsable. Capaz.
              <br data-id="element-62" />
              <br data-id="element-63" />
              Pero por dentro vivís cansada, tensa y con una culpa que no sabés
              de dónde viene.
              <br data-id="element-64" />
              <br data-id="element-65" />
              Culpa por descansar. Culpa por decir que no. Culpa por pensar en
              vos.
              <br data-id="element-66" />
              <br data-id="element-67" />
              Incluso cuando sabés que lo necesitás.
            </p>
          </motion.div>

          {/* Section 2 */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="text-center relative" data-id="element-68">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-r from-transparent via-purple-50/50 to-transparent -z-10" data-id="element-69" />
            <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-6" data-id="element-70">
              El cansancio que nadie ve
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-71">
              No es cansancio físico. Es un cansancio del alma.
              <br data-id="element-72" />
              <br data-id="element-73" />
              Dormís, pero no descansás. Sonreís, pero estás vacía. Funcionás,
              pero no vivís.
              <br data-id="element-74" />
              <br data-id="element-75" />Y lo más pesado no es el cansancio. Es la sensación
              constante de estar fallando… incluso cuando nadie te lo pide.
            </p>
          </motion.div>

          {/* Section 3 */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="text-center" data-id="element-76">
            <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-6" data-id="element-77">
              No es que estés rota
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-78">
              No te falta fuerza. No sos débil. No estás "mal".
              <br data-id="element-79" />
              <br data-id="element-80" />
              Lo que te pasa tiene una raíz más profunda.
              <br data-id="element-81" />
              <br data-id="element-82" />
              Vivís desde lealtades emocionales invisibles. Mandatos familiares.
              Culpa heredada. Historias que prometiste no repetir… pero que
              seguís cargando.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-24 px-4 md:px-8 bg-purple-900 text-white relative overflow-hidden" data-id="element-83">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-84" />
        <div className="absolute top-0 right-0 w-96 h-96 bg-purple-600/30 rounded-full blur-[100px]" data-id="element-85" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-600/30 rounded-full blur-[100px]" data-id="element-86" />

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center relative z-10" data-id="element-87">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-88">
            <h2 className="font-serif text-4xl md:text-5xl mb-8 leading-tight" data-id="element-89">
              ¿Y si sanar no fuera{' '}
              <span className="italic text-purple-300" data-id="element-90">romper</span>?
            </h2>
            <p className="text-lg text-purple-100 leading-relaxed mb-8" data-id="element-91">
              <strong className="text-white" data-id="element-92">Sanar Sin Culpa</strong> es una
              guía creada para mujeres que quieren soltar la culpa sin destruir
              vínculos, sin confrontar a nadie y sin convertirse en otra
              persona.
            </p>
            <p className="text-lg text-purple-100 leading-relaxed mb-8" data-id="element-93">
              No te empuja. No te juzga. No te exige sanar rápido.
            </p>
            <p className="text-lg text-purple-100 leading-relaxed mb-10" data-id="element-94">
              Te acompaña suavemente a:
            </p>

            <ul className="space-y-4 mb-10" data-id="element-95">
              {['Reconocer la raíz', 'Honrar tu historia', 'Soltar sin traicionar', 'Elegirte sin culpa'].map((item, i) => <li key={i} className="flex items-center gap-3 text-xl font-medium" data-id="element-96">
                  <div className="bg-purple-700 p-1.5 rounded-full" data-id="element-97">
                    <Sparkles className="w-4 h-4 text-purple-200" data-id="element-98" />
                  </div>
                  {item}
                </li>)}
            </ul>

            <button onClick={scrollToPurchase} className="bg-white text-purple-900 px-8 py-4 rounded-full font-medium text-lg hover:bg-purple-50 transition-colors duration-300 w-full md:w-auto" data-id="element-99">
              Quiero empezar mi camino
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-100">
            <img src={MAIN_IMAGE} alt="Libro Sanar Sin Culpa" className="rounded-xl shadow-2xl rotate-2 hover:rotate-0 transition-transform duration-500 cursor-pointer" onClick={scrollToPurchase} data-id="element-101" />
          </motion.div>
        </div>
      </section>

      {/* Author/Story Section */}
      <section className="py-20 px-4 md:px-8 bg-[#FAF9F6]" data-id="element-102">
        <div className="max-w-3xl mx-auto text-center" data-id="element-103">
          <BookOpen className="w-10 h-10 text-purple-300 mx-auto mb-6" data-id="element-104" />
          <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-8" data-id="element-105">
            Un camino distinto
          </h2>
          <div className="prose prose-lg mx-auto text-gray-600" data-id="element-106">
            <p data-id="element-107">
              Este libro no nació desde un pedestal. Nació desde un quiebre
              silencioso.
            </p>
            <p data-id="element-108">
              Cuando todo estaba "bien" por fuera… pero por dentro había
              cansancio, culpa y una sensación constante de traicionarse.
            </p>
            <p data-id="element-109">
              No fue creado para vender. Fue creado para sobrevivir
              emocionalmente. Y luego, para acompañar a otras mujeres.
            </p>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 md:px-8 bg-gradient-to-b from-white to-pink-50/30" data-id="element-110">
        <div className="max-w-6xl mx-auto" data-id="element-111">
          <div className="text-center mb-12" data-id="element-112">
            <span className="bg-pink-100 text-pink-700 px-4 py-1 rounded-full text-sm font-bold tracking-wider uppercase mb-4 inline-block" data-id="element-113">
              Regalo Exclusivo
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-3" data-id="element-114">
              Bonos Especiales
            </h2>
            <p className="text-pink-600 font-bold text-xl" data-id="element-115">
              Gratis por el día de hoy
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-116">
            {/* Bonus 1 - Lealtades Invisibles */}
            <motion.div whileHover={{
            scale: 1.02
          }} className="bg-white p-6 rounded-2xl shadow-lg border border-pink-100 cursor-pointer" onClick={scrollToPurchase} data-id="element-117">
              <div className="relative mb-4" data-id="element-118">
                <img src={BONUS_IMAGE} alt="Bono Lealtades Invisibles" className="w-full rounded-xl shadow-md" data-id="element-119" />
                <div className="absolute -top-3 -right-3 bg-pink-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg" data-id="element-120">
                  GRATIS
                </div>
              </div>
              <h3 className="font-serif text-xl text-gray-900 mb-2" data-id="element-121">
                Lealtades Invisibles
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-122">
                Cómo honrar sin repetir
              </p>
              <ul className="space-y-2 text-sm text-gray-600" data-id="element-123">
                <li className="flex items-center gap-2" data-id="element-124">
                  <CheckCircleIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-125" />
                  <span data-id="element-126">Identificar patrones heredados</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-127">
                  <CheckCircleIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-128" />
                  <span data-id="element-129">Ejercicios de liberación</span>
                </li>
              </ul>
            </motion.div>

            {/* Bonus 2 - Ritual Suave */}
            <motion.div whileHover={{
            scale: 1.02
          }} className="bg-white p-6 rounded-2xl shadow-lg border border-pink-100 cursor-pointer" onClick={scrollToPurchase} data-id="element-130">
              <div className="relative mb-4" data-id="element-131">
                <img src={BONUS_IMAGE_2} alt="Bono Ritual Suave para Soltar la Culpa" className="w-full rounded-xl shadow-md" data-id="element-132" />
                <div className="absolute -top-3 -right-3 bg-pink-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg" data-id="element-133">
                  GRATIS
                </div>
              </div>
              <h3 className="font-serif text-xl text-gray-900 mb-2" data-id="element-134">
                Ritual Suave para Soltar la Culpa
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-135">
                Práctica guiada de liberación
              </p>
              <ul className="space-y-2 text-sm text-gray-600" data-id="element-136">
                <li className="flex items-center gap-2" data-id="element-137">
                  <CheckCircleIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-138" />
                  <span data-id="element-139">Ritual paso a paso</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-140">
                  <CheckCircleIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-141" />
                  <span data-id="element-142">Soltar con amor</span>
                </li>
              </ul>
            </motion.div>

            {/* Bonus 3 - Diario Emocional */}
            <motion.div whileHover={{
            scale: 1.02
          }} className="bg-white p-6 rounded-2xl shadow-lg border border-pink-100 cursor-pointer" onClick={scrollToPurchase} data-id="element-143">
              <div className="relative mb-4" data-id="element-144">
                <img src={BONUS_IMAGE_3} alt="Bono Diario Emocional Guiado" className="w-full rounded-xl shadow-md" data-id="element-145" />
                <div className="absolute -top-3 -right-3 bg-pink-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg" data-id="element-146">
                  GRATIS
                </div>
              </div>
              <h3 className="font-serif text-xl text-gray-900 mb-2" data-id="element-147">
                Diario Emocional Guiado
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-148">
                Volver a vos sin exigencia
              </p>
              <ul className="space-y-2 text-sm text-gray-600" data-id="element-149">
                <li className="flex items-center gap-2" data-id="element-150">
                  <CheckCircleIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-151" />
                  <span data-id="element-152">Reflexiona y siente</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-153">
                  <CheckCircleIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-154" />
                  <span data-id="element-155">Reconecta con vos</span>
                </li>
              </ul>
            </motion.div>
          </div>

          <div className="text-center" data-id="element-156">
            <p className="text-gray-500 text-sm mb-2" data-id="element-157">
              Valor total de los bonos:
            </p>
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-158">
              <span className="text-3xl font-bold text-gray-400 line-through" data-id="element-159">
                $29.970
              </span>
              <span className="text-4xl font-bold text-pink-600" data-id="element-160">
                ¡GRATIS HOY!
              </span>
            </div>
            <button onClick={scrollToPurchase} className="bg-purple-600 text-white px-8 py-4 rounded-full font-medium text-lg hover:bg-purple-700 transition-colors duration-300 shadow-lg" data-id="element-161">
              Quiero todos los bonos gratis
            </button>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 md:px-8 bg-[#FAF9F6]" data-id="element-162">
        <div className="max-w-6xl mx-auto" data-id="element-163">
          <h2 className="font-serif text-3xl md:text-4xl text-center text-gray-900 mb-16" data-id="element-164">
            Mujeres que ya están sanando
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-165">
            <TestimonialCard name="Carolina M." age={34} location="Buenos Aires" text="Sentía que cargaba con el peso del mundo. Este libro me ayudó a entender que soltar no es abandonar, es cuidarme. Lloré, sané y me sentí abrazada en cada página." data-id="element-166" />
            <TestimonialCard name="Valeria S." age={41} location="Córdoba" text="Nunca pensé que un libro digital pudiera tocarme tan profundo. Es como si la autora me conociera de toda la vida. La culpa ya no maneja mis decisiones." data-id="element-167" />
            <TestimonialCard name="Andrea R." age={29} location="Rosario" text="El capítulo sobre las lealtades invisibles me cambió la vida. Entendí por qué repetía la historia de mi madre. Gracias por esta herramienta tan amorosa." data-id="element-168" />
            <TestimonialCard name="Patricia L." age={45} location="Mendoza" text="Lo leo cada vez que siento que la exigencia me gana. Es mi refugio. Me enseñó a decir que no sin sentirme la peor persona del mundo." data-id="element-169" />
            <TestimonialCard name="Sofía G." age={38} location="La Plata" text="Hermoso, profundo y real. No es el típico libro de autoayuda que te dice 'sé feliz'. Te acompaña a transitar el dolor para transformarlo." data-id="element-170" />
          </div>
        </div>
      </section>

      {/* Purchase Section */}
      <section id="purchase-section" className="py-24 px-4 md:px-8 bg-white" data-id="element-171">
        <div className="max-w-4xl mx-auto text-center" data-id="element-172">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-purple-50 to-pink-50 p-8 md:p-16 rounded-[3rem] shadow-2xl border border-purple-100 relative overflow-hidden" data-id="element-173">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400" data-id="element-174" />

            <h2 className="font-serif text-3xl md:text-5xl text-gray-900 mb-6" data-id="element-175">
              Para mujeres que ya cargaron demasiado
            </h2>

            <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-176">
              Si estás cansada de ser la fuerte. Si sentís que vivir no debería
              doler tanto. Si querés sanar sin romperte por dentro…
              <br data-id="element-177" />
              <br data-id="element-178" />
              <span className="font-medium text-purple-800" data-id="element-179">
                Este espacio es para vos.
              </span>
            </p>

            <div className="flex flex-col items-center justify-center gap-6" data-id="element-180">
              <div className="text-center" data-id="element-181">
                <p className="text-gray-500 text-sm uppercase tracking-wide mb-2" data-id="element-182">
                  Precio Especial Hoy
                </p>
                <div className="flex items-center justify-center gap-3" data-id="element-183">
                  <span className="text-6xl font-serif font-bold text-gray-900" data-id="element-184">
                    $19.990
                  </span>
                  <span className="text-xl text-gray-400 line-through" data-id="element-185">
                    $39.990
                  </span>
                </div>
              </div>

              <a href={CHECKOUT_URL} className="w-full max-w-md bg-purple-600 text-white text-xl font-bold py-5 px-8 rounded-full shadow-xl hover:bg-purple-700 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-3 animate-pulse-slow" data-id="element-186">
                <span data-id="element-187">DESCARGAR AHORA</span>
                <ArrowRight className="w-6 h-6" data-id="element-188" />
              </a>

              <div className="flex items-center gap-4 text-sm text-gray-500 mt-4" data-id="element-189">
                <span className="flex items-center gap-1" data-id="element-190">
                  <CheckCircleIcon className="w-4 h-4" data-id="element-191" /> Acceso Inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-192">
                  <CheckCircleIcon className="w-4 h-4" data-id="element-193" /> Pago Seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-194">
                  <CheckCircleIcon className="w-4 h-4" data-id="element-195" /> Garantía de Calidad
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 py-12 text-center text-gray-400 text-sm" data-id="element-196">
        <p data-id="element-197">© 2025 Sanar Sin Culpa. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-198">Una guía hecha con amor para tu proceso.</p>
      </footer>
    </div>;
}
function CheckCircleIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-199">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-200" />
      <polyline points="22 4 12 14.01 9 11.01" data-id="element-201" />
    </svg>;
}